import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PermissionService } from 'src/app/services';
import { ApiAttributesMappingService } from 'src/app/services/api-attributes-mapping.service';

@Component({
  selector: 'app-attributes-mapping-managment',
  templateUrl: './attributes-mapping-managment.component.html',
  styleUrls: ['./attributes-mapping-managment.component.css']
})
export class AttributesMappingManagmentComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  switchTab: string = 'list'
  attrIds: string[] = [];

  @Input() set data(value) {

    if (value != null) {

      this.attrIds = value;
    }
  }

  constructor(
    private apiAttrsMappingService: ApiAttributesMappingService,
    public activeModal: NgbActiveModal,
    public permissionAccessService: PermissionService
  ) { }


  ngOnInit(): void {

    // СЛУШАЕМ ИЗМЕНЕНИЕ ДАННЫХ В КОМПОНЕНТАХ ДЛЯ АВТО ПЕРЕКЛЮЧЕНИЯ МЕЖДУ ВЛКАДКАМИ ОКНА
    this.subscriptions.add(
      this.apiAttrsMappingService.listenerSwitchTab().subscribe(val => {

        if (val) {

          this.switchTab = val;
        }

      })
    );
  }

  /**
   * 
   * @param tab 
   */
  switchTabs(tab: string) {

    this.switchTab = tab;

  }

}
